export default "__VITE_ASSET__5929854b__"